import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import GlobalStyles from './common/style/global';
import {Provider} from "react-redux";
import {store} from "./app/store";
import {BrowserRouter, HashRouter} from 'react-router-dom';


const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <Provider store={store}>
        <GlobalStyles/>
        <HashRouter>
            <App/>
        </HashRouter>
    </Provider>
);

reportWebVitals();
